var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "height": "200px",
      "width": "200px",
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 480 480",
      "xml:space": "preserve",
      "fill": "#000000"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#f0f0f0"
    },
    attrs: {
      "d": "M240,0C134.136,0,48,86.136,48,192c0,104.968,122.016,288,192,288s192-183.032,192-288 C432,86.136,345.864,0,240,0z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f85766"
    },
    attrs: {
      "d": "M240,48c-74.992,0-136,61.008-136,136s61.008,136,136,136s136-61.008,136-136S314.992,48,240,48z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fcbcc2"
    },
    attrs: {
      "d": "M294.064,141.752c-3.608-26.608-26.48-47.184-54.064-47.184s-50.456,20.576-54.064,47.184 c-20.48,3.512-36.096,21.128-36.096,42.248c0,21.28,16.736,37.896,34.16,41.936V272h112v-46.064 c17.424-4.04,34.16-20.656,34.16-41.936C330.16,162.872,314.536,145.264,294.064,141.752z"
    }
  }), _c('circle', {
    staticStyle: {
      "fill": "#fb9aa3"
    },
    attrs: {
      "cx": "240",
      "cy": "392",
      "r": "32"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f85766"
    },
    attrs: {
      "d": "M240,432c-22.056,0-40-17.944-40-40s17.944-40,40-40s40,17.944,40,40S262.056,432,240,432z M240,368 c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S253.232,368,240,368z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }